import * as shared from "@/styles/shared";
import { AddressCard } from "./AddressCard";
import { useAddresses } from "./AddressesContext";

const AddressList = () => {
  const { addresses } = useAddresses();

  return (
    <div className={shared.formStack}>
      {addresses.map((addr) => (
        <AddressCard key={addr.id} address={addr} />
      ))}
    </div>
  );
};

export { AddressList };
